module.exports = __webpack_public_path__ + "static/practice-04-cover-f3a111c5be8cf89f515b3c843532ced9.jpg";